export default __webpack_public_path__ + "static/media/ico_icu.21e0d3ab.svg";